import(/* webpackMode: "eager" */ "/repo/apps/klant/src/app/global-error.tsx");
